export const SET_COOKIE_ACCEPTED = "cookieAccepted/SET_COOKIE_ACCEPTED";
